import { withTranslation } from "react-i18next";
import withRouter from "../../../components/Common/withRouter";


const DeductionMaster = (props) => {

};

export default withRouter(withTranslation()(DeductionMaster))